const rawBase = process.env.REACT_APP_API_URL || "http://localhost:3000";
const BASE_URL = (typeof rawBase === "string" ? rawBase.trim() : rawBase).replace(/\/+$/, "");

const MAX_MESSAGE_LENGTH = 2000;
const MAX_STACK_LENGTH = 4000;
const RATE_WINDOW_MS = 60 * 1000;
const MAX_EVENTS_PER_WINDOW = 10;

let windowStart = 0;
let windowCount = 0;
let loggerReady = false;

const normalizeText = (value, max) => {
  if (!value) return null;
  const text = typeof value === "string" ? value : String(value);
  return text.length > max ? text.slice(0, max) : text;
};

const canSend = () => {
  const now = Date.now();
  if (!windowStart || now - windowStart > RATE_WINDOW_MS) {
    windowStart = now;
    windowCount = 0;
  }
  if (windowCount >= MAX_EVENTS_PER_WINDOW) return false;
  windowCount += 1;
  return true;
};

const sendLog = (payload) => {
  if (!canSend()) return;
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
  if (!token) return;

  const body = JSON.stringify(payload);

  fetch(`${BASE_URL}/api/logs/frontend`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body,
    keepalive: true,
  }).catch(() => {});
};

const report = (level, message, stack, route, userAgent) => {
  const normalizedMessage = normalizeText(message, MAX_MESSAGE_LENGTH);
  if (!normalizedMessage) return;

  sendLog({
    level,
    message: normalizedMessage,
    stack: normalizeText(stack, MAX_STACK_LENGTH),
    route: normalizeText(route, 255),
    userAgent: normalizeText(userAgent, 255),
  });
};

export const initClientLogger = () => {
  if (loggerReady || typeof window === "undefined") return;
  loggerReady = true;

  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    try {
      report(
        "error",
        args.map((item) => (typeof item === "string" ? item : JSON.stringify(item))).join(" "),
        null,
        window.location?.pathname,
        navigator.userAgent
      );
    } catch {}
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    try {
      report(
        "warning",
        args.map((item) => (typeof item === "string" ? item : JSON.stringify(item))).join(" "),
        null,
        window.location?.pathname,
        navigator.userAgent
      );
    } catch {}
    originalWarn.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    report(
      "error",
      event.message || "Error no capturado",
      event.error?.stack,
      window.location?.pathname,
      navigator.userAgent
    );
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    const message =
      typeof reason === "string"
        ? reason
        : reason?.message || "Promise rechazada sin manejar";
    report(
      "error",
      message,
      reason?.stack,
      window.location?.pathname,
      navigator.userAgent
    );
  });
};

export default initClientLogger;
